import React from "react";
import { FormattedMessage } from "react-intl";
import cn from "classnames";

import { ITaskEditorProps } from "../../../../../../common/types";

import { setItem, hasItem } from "../../../../../cookie";

import ScoreEditor from "../../../../Score";

import EditorBar, { FlexLeft, FlexRight, Center } from "../../../EditorBar";

import getScale from "../../Common/getScale";
import getScore from "../../Common/getScore";
import getTempo from "../../Common/getTempo";
import ChangeScale from "../../Common/ChangeScale";
import ChangeTempo from "../../Common/ChangeTempo";
import useExerciseEditor from "../../Common/useExerciseEditor";
import AudioUploader from "../../Common/AudioUploader";

import messages from "./messages";
import ChangeColor from "../../Common/ChangeColor";

const BarlineEditor = ({ plan, taskIndex, toggleInlineEditor, publicView, inlineEditorOpen }: ITaskEditorProps) => {
    const {
        openChanger,
        playable,
        handleChangeOpen,
        setPopupRef,
        storeScore,
        changeTempo,
        setPlayable,
        exportScore,
    } = useExerciseEditor({ plan, inlineEditorOpen, taskIndex });
    const task = plan.tasks[taskIndex];
    const forwardProps = {
        plan,
        taskIndex,
        openChanger,
        handleChangeOpen,
        setPopupRef,
    }
    return (
        <div>
            {inlineEditorOpen && (
                <ScoreEditor
                    score={JSON.parse(JSON.stringify(getScore(plan, task) || {}))}
                    scale={getScale(plan, task)}
                    tempo={getTempo(plan, task)}
                    taskType="barline"
                    setScore={storeScore}
                    changeTempo={changeTempo}
                />
            )}
            {!publicView && (
                <EditorBar>
                    <FlexLeft>
                        {task && task.data && <ChangeScale {...forwardProps} />}
                        <AudioUploader plan={plan} taskIndex={taskIndex} />
                    </FlexLeft>
                    <Center
                        disabled={(inlineEditorOpen && !playable)}
                        tooltip={!playable && inlineEditorOpen && <FormattedMessage {...messages.createScoreTooltip} />}
                        onClick={() => {
                            toggleInlineEditor(!inlineEditorOpen);
                            setPlayable(true);
                            if (inlineEditorOpen) {
                                exportScore();
                            }
                            setItem("rhytNameDone", "1", 60 * 60 * 24 * 365, "/");
                        }}
                        className={cn(
                            !(inlineEditorOpen && !playable) && !hasItem("rhytNameDone") && !task.ref && "pulsate"
                        )}
                    >
                        {inlineEditorOpen ? (
                            <FormattedMessage {...messages.stopEdit} />
                        ) : (
                            <FormattedMessage {...messages.editScore} />
                        )}
                    </Center>
                    <FlexRight>
                        <ChangeColor
                            {...forwardProps}
                            color={task.data?.color}
                        />
                        <ChangeTempo {...forwardProps} />
                    </FlexRight>
                </EditorBar>
            )}
        </div>
    );
}

export default BarlineEditor;
